import { render, staticRenderFns } from "./BBCView.vue?vue&type=template&id=718ea502&scoped=true"
import script from "./BBCView.vue?vue&type=script&lang=js"
export * from "./BBCView.vue?vue&type=script&lang=js"
import style0 from "./BBCView.vue?vue&type=style&index=0&id=718ea502&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718ea502",
  null
  
)

export default component.exports